import React from "react"
import Cross from "assets/svgs/Cross"
import { ProgressMeetFeedback } from "domain/model/ProgressMeet"

interface FeedbackCardModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  feedbackData: ProgressMeetFeedback | null
}

export default function FeedbackCardModal({ isOpen, setIsOpen, feedbackData }: FeedbackCardModalProps) {
  if (!isOpen || !feedbackData) return null

  const feedbackSections = [
    {
      title: "Live Classes Feedback :",
      description: "(Scale: 1 - Poor to 5 - Excellent)",
      key: "live_classes_feedback",
    },
    {
      title: "Mentorship Session Feedback : ",
      description: "(Scale: 1 - Poor to 5 - Excellent)",
      key: "mentorship_session_feedback",
    },
    {
      title: "Exams and Milestone Exams Feedback :",
      description: "(Scale: 1 - Poor to 5 - Excellent)",
      key: "exams_feedback",
    },
    {
      title: "Content Quality Feedback (Notes and Assignments) :",
      description: "(Scale: 1 - Poor to 5 - Excellent)",
      key: "content_quality_feedback",
    },
    {
      title: "Doubt Support Feedback (Problem-Solving Doubts) :",
      description: "(Scale: 1 - Poor to 5 - Excellent)",
      key: "doubt_support_feedback",
    },
  ]

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-[rgba(12,12,12,0.9)] z-0"></div>

      <div className="relative bg-white w-[535px] h-[576px] p-6 z-10 rounded-lg shadow-lg flex flex-col">
        <div className="flex justify-between mb-3 flex-shrink-0">
          <div>
            <h4 className="text-gray-800 font-inter text-lg font-semibold">Progress Meeting Feedback</h4>
            <p className="text-gray-600 font-inter text-sm font-medium pt-1">
              Provide your valuable feedback to increase meeting quality.
            </p>
          </div>
          <button className="hover:bg-gray-300 duration-300 rounded p-1" onClick={() => setIsOpen(false)}>
            <Cross />
          </button>
        </div>

        <div className="flex justify-between p-3 items-start gap-4 rounded bg-gray-100 h-[57px] flex-shrink-0">
          <div className="text-gray-800 font-inter text-sm font-semibold mt-1">
            User Email ID <span className="text-red-600">*</span>
          </div>
          <div className="rounded border border-gray-300 bg-white flex w-[300px] h-[33px] py-1 px-4 items-center overflow-hidden whitespace-nowrap text-ellipsis">
            <p className="text-gray-600 font-inter text-sm font-normal">{feedbackData.email}</p>
          </div>
        </div>

        <div className="overflow-hidden hover:overflow-y-auto scrollbar-thin gray-scrollbar transition-all duration-300 ease-in-out flex-1 mt-4">
          <div className="flex flex-col gap-3">
            {feedbackSections.map((section, idx) => (
              <div key={idx} className="mt-2">
                <p className="text-[#333] font-inter text-[14px] font-semibold">{section.title}</p>
                <p className="text-[#646464] font-inter text-[14px] font-normal leading-normal">
                  {section.description}
                  <span className="text-[#DC2626] font-inter text-[14px] font-semibold leading-normal">*</span>
                </p>
                <div className="flex gap-1 mt-2">
                  {Array.from({ length: 10 }).map((_, index) => (
                    <div
                      key={index}
                      className={`flex w-[44px] h-[29px] p-[6px_11px] justify-center items-center flex-shrink-0 rounded-[6px] bg-[#F9F9F9] font-semibold
              ${feedbackData[section.key as keyof typeof feedbackData] === index + 1 ? "!bg-[#88CC30]" : ""} 
              `}
                    >
                      {index + 1}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6">
            <p className="text-gray-800 font-inter text-sm font-semibold">Suggestions or Feedback</p>
            <div className="mt-2 p-3 border border-gray-300 rounded bg-gray-100 text-gray-600 text-sm overflow-y-auto scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200">
              {feedbackData.suggestions || "No additional feedback provided."}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
